<script>
  // @ts-check

    /**
     * @type {import('svelte/store').Writable<boolean>}
     */
    export let sidebarStore;
    $: sidebarOpen = $sidebarStore;
</script>

    <!-- Overlay -->
    <div class="touch-none fixed top-0 left-0 w-full h-full bg-black transition-opacity duration-300 ease-in-out z-20" 
        class:opacity-50={sidebarOpen} 
        class:opacity-0={!sidebarOpen} 
        class:pointer-events-none={!sidebarOpen} 
        on:click={() => sidebarStore.update((open) => !open)}></div>

<div>
</div>
  <div class="fixed top-0 left-0 h-full w-64 bg-blue-600 rounded-br-3xl px-5 py-8 transition-all duration-300 ease-in-out transform md:translate-x-0 z-20 md:max-w-[256px]" class:translate-x-[-100%]={!sidebarOpen}>
    <img alt="logo" src="/vanya_website_logo.png" class="h-28 md:h-40 mx-auto my-4" />
    <div class="">
      <slot name="side"></slot>
    </div>

  </div>
  
  <div class="md:ml-[256px]">
    <slot></slot>
  </div>
